import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs';
import { TableColumn } from '../../../../core/models/table-column';
import { MatTableDataSource } from '@angular/material/table';
import { EventIndexModel } from '../../../../core/models/event-index.model';
import { tap } from 'rxjs/operators';
import { Sort } from '@angular/material/sort';
import { AbsenceListItem } from 'src/app/core/models/client-models';

@Component({
  selector: 'app-absence-selection-list-table',
  templateUrl: './absence-selection-list-table.component.html',
  styleUrls: ['./absence-selection-list-table.component.scss'],
})
export class AbsenceSelectionListTableComponent implements OnInit, OnDestroy {
  @Input() absenceList$: Observable<AbsenceListItem[]>;
  @Input() tableColumns$: Observable<TableColumn[]>;
  @Input() selectedIndex$: Observable<number>;
  @Output() onClickEvent = new EventEmitter<AbsenceListItem>();
  @Output() onHoverEvent = new EventEmitter<number>();

  displayedColumns: string[] = [];
  dataSource = new MatTableDataSource<AbsenceListItem>();
  onResize$ = new Subject<EventIndexModel>();

  private subscriptions = new Subscription();

  constructor() {}

  ngOnInit() {
    this.registerColumns();
    this.registerDataUpdate();
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  onHover(index: number) {
    this.onHoverEvent.emit(index);
  }

  onClick(row: AbsenceListItem) {
    this.onClickEvent.emit(row);
  }

  onColumnResize(event, column) {
    const index = this.displayedColumns.findIndex(
      (element) => element == column
    );
    this.onResize$.next({
      event,
      index,
    } as EventIndexModel);
  }

  onSort(event: Sort) {}
  private registerDataUpdate() {
    this.subscriptions.add(
      this.absenceList$.subscribe((value) => {
        this.dataSource.data = [];
        this.dataSource.data = value;
      })
    );
  }

  private registerColumns() {
    this.subscriptions.add(
      this.tableColumns$
        .pipe(
          tap((columns) => {
            this.displayedColumns = [];
            columns.forEach((column) => {
              if (column.selected) {
                this.displayedColumns.push(column.name);
              }
            });
          })
        )
        .subscribe()
    );
  }
}
